<template>
  <div class="container-fluid" v-if="ready">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <KundeProjektInfos />
            <Media />
          </div>
          <div class="col-6">
            <Projektphasen :bauprojekt_id="bauprojekt" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <bpAssets />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bpAssets from "@/widget/kunde/bpAssets.vue";
import KundeProjektInfos from "@/widget/kunde/ProjektInfos.vue";
import { mapGetters } from "vuex";
//import KundeAusstattung from "../../widget/kunde/KundeAusstattung.vue";
import Media from "@/widget/kunde/KundeMedia.vue";
import Projektphasen from "@/widget/Projektphasen.vue";

export default {
  name: "KundeWohnung",
  components: {
    bpAssets,
    KundeProjektInfos,
    //KundeAusstattung,
    Media,
    Projektphasen,
  },
  data() {
    return {
      wohnungId: false,
      wohnung: false,
      haus: false,
      bauprojekt: false,
      ready: false,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      hauser: "app/hauser",
      bauprojekte: "app/bauprojekte",
      wohnungen: "app/wohnungen",
    }),
  },
  created() {
    this.wohnungId = this.$route.params.wohnung_id;
    this.wohnung = this.wohnungen.find((w) => w.id == this.wohnungId);
    this.haus = this.hauser.find((h) => h.id == this.wohnung.haus);
    this.bauprojekt = this.haus.haus_bp;
    this.ready = true;
  },
};
</script>

<style>
  img{
    width: 100%;
  }
</style>
